import { CheckBoxWithLabelWidget } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';

const checkboxListStyle = style({
  flex: '1 1 auto',
});

export const optionHeaderStyle = style({
 fontWeight: 'bold',
});

const optionListStyle = style({
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: 20,
  paddingTop: 12,
});

const headerIconStyle = style({
  height: 14,
  width: 14,
  marginRight: 12,
  verticalAlign: 'text-top',
});

export const itemWrapperStyle = style({
  display: 'flex',
  marginBottom: 12,
  alignItems: 'center',
});

const mandatoryStyle = style({
  paddingLeft: 6,
  paddingRight: 6,
});

export type LinkedTaskOptionCheckboxType = 'succeed' | 'fail';

export interface LinkedTaskOptionCheckboxItem {
  label: string;
  isChecked?: boolean;
  handleClick?: (checked: boolean) => void; // Selection handler
  isMandatory?: boolean; // If it is always checked on, display without checkbox
  actionComponent?: React.ReactNode; // Optional action component to render next to item
}

export interface LinkedTaskOptionCheckboxListProps {
  type: LinkedTaskOptionCheckboxType;
  items: LinkedTaskOptionCheckboxItem[];
}

export function LinkedTaskOptionCheckboxList(props: LinkedTaskOptionCheckboxListProps): JSX.Element {

  function renderIconAndMessage() {
    if (props.type === 'succeed') {
      return (
        <>
          <img src={imgPath('flow_run_succeeded.svg')} className={headerIconStyle} alt={''} />
          {Messages.linkedTasksOptionsSucceedHeader()}
        </>
      );
    } else {
      return (
        <>
          <img src={imgPath('flow_run_error.svg')} className={headerIconStyle} alt={''} />
          {Messages.linkedTasksOptionsFailHeader()}
        </>
      );
    }
  }

  function renderItem(item: LinkedTaskOptionCheckboxItem) {
    return (
      <div className={itemWrapperStyle} key={item.label}>
        {item.isMandatory ?
          <><img src={imgPath('check_14px-small.svg')} alt={Messages.linkedTasksEnabledByDefault()} className={mandatoryStyle}/> {item.label} </> :
          <CheckBoxWithLabelWidget
            label={item.label}
            checked={item.isChecked}
            handleChange={item.handleClick}
            testId={`linked-tasks-option-checkbox-${item.label}`}
          />
        }
        {item.actionComponent ? <div>{item.actionComponent}</div> : null}
      </div>
    );
  }

  return (
    <div className={checkboxListStyle}>
      <div className={optionHeaderStyle}>{renderIconAndMessage()}</div>
      <div className={optionListStyle}>
        {props.items.map(renderItem)}
      </div>
    </div>
  );
}
